import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Link,
	Grid,
	Button,
	Typography
} from '@material-ui/core';

import Fido from "../utils/Fido";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

import SubNavPanelsWrapper from '../components/SubNavPanelsWrapper';
import SourcesTabs from '../components/SourcesTabs';
import {useSelectedSubNavTab, useIsEdit} from "../utils/CustomHooks";
import GeneralSettingsPanel from '../components/GeneralSettingsPanel';
import GSuiteConfig from '../components/GSuiteConfig';

const styles = makeStyles(theme => ({
	link: {
		cursor: "pointer",
		fontSize: "1rem",
		marginBottom: 3
	},

	buttonGrid: {
		marginTop: theme.spacing(2),

		"& button": {
			minWidth: theme.spacing(16)
		}
	},

	paddedLayout: {
		[theme.breakpoints.down('xs')]: {
			paddingTop: theme.spacing(2)
		}
	}
}));

function SourcesSettings(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const [selectedTab, setSelectedTab] = useState(false);
	const tabs = ["gsuite"];
	let {location, updateHeader, resetHeader, showSnackbar, history, setFullScreenClassName,
		bannerHeight, banner, showBanner, updateUser, setBannerClassName, hasNudgeBanner} = props;
	const [selectedPanel, setSelectedPanel] = useState();
	const [libraryTopics, setLibraryTopics] = useState();
	const [rtNotifications, setRtNotifications] = useState([]);
	const getSelectedTab = useSelectedSubNavTab(location, tabs);

	// set selected tab
	useEffect(() => {
		setSelectedTab(getSelectedTab());
	}, [getSelectedTab, setSelectedTab]);

	const tabClicked = (event, tab) => {
		setSelectedTab(tab);
		props.history.push(`/settings/sources/${tab}`);
	};
	
	return (
		<React.Fragment>
			<SourcesTabs
				selectedTab={tabs[0]}
				tabClicked={tabClicked}
				hasNudgeBanner={hasNudgeBanner}
				setBannerClassName={setBannerClassName} />
			<SubNavPanelsWrapper>
				<Grid container justify="flex-end" >
					
					<GSuiteConfig showSnackbar={showSnackbar}/>						
					
				</Grid>
			</SubNavPanelsWrapper>
		</React.Fragment>
		
	);
}

SourcesSettings.propTypes = {
	history: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired
};

export default SourcesSettings;